module.exports = __webpack_public_path__ + "static/media/26UNRWA16.05833f5a.jpg";